import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import search from "../assets/search.png"
import change from "../assets/change.png"
import add from "../assets/add.png"
import fb from "../assets/fbc.png"
import f from "../assets/f.png"
import insta from "../assets/insta.png"
import store from "../assets/store.png"
import twitter from "../assets/twitter.png"
import { Social } from './Socialarray'
import Createdroplist from './Createdroplist'
import { Sosialarray } from './Socialarray'
import ProfileModal from '../profile/ProfileModal'

function Addaccount() {
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5",height:"100vh" }}>
            <Navbars />
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
                <div className='inner_div  mb-5 pb-5' style={{marginTop:"85px",width:"100%"}}>
                    <div className='ps-3 pe-3' style={{ position: "relative" }}>
                        <input placeholder='Search Business id, Business name, Zip code etc ' className='add_search' />
                        <img src={search} className="search_img" />
                    </div>
                    <div className='ps-3 pe-3 mt-3'>
                        <div className='social_media_div  '>
                            <div className='add_div'>
                                <img src={add} />
                            </div>
                            <div className='w-100' >
                                <div className='d-flex gap-4 flex-wrap mt-2'>
                                    <div className='d-flex gap-1 align-items-center'>
                                        <img src={fb} />
                                        <p className='social_headings'>Facebook</p>
                                    </div>
                                    <div className='d-flex gap-1 align-items-center'>
                                        <img src={insta} />
                                        <p className='social_headings'>Instagram</p>
                                    </div>
                                    <div className='d-flex gap-1 align-items-center'>
                                        <img src={twitter} />
                                        <p className='social_headings'>Twitter</p>
                                    </div>
                                </div>
                                <div className='d-flex gap-3 flex-wrap mt-3'>
                                    {
                                        Social.map((value, index) => {
                                            return (<>
                                                <div key={index} className='social_user'>
                                                    <img src={value.img} />
                                                    <p className='user'>{value.name}</p>
                                                </div>




                                            </>)
                                        })
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='d-flex gap-2 justify-content-between mt-3 mb-3  ps-3 pe-3'>
                        <Createdroplist />
                        <div className='change_div'>
                            <img src={change} />
                        </div>
                    </div>
                    <div className=''>
                        {
                            Sosialarray.map((value, index) => {
                                return (<>
                                    <div className='contact_div' key={index}>
                                        <div className='d-flex  align-items-center gap-2'>
                                            <img src={value.img} />
                                            <p className='contact_name'>{value.name}</p>
                                        </div>
                                        <ProfileModal />
                                    </div>
                                </>)
                            })
                        }

                    </div>
                </div>
            </div>
        </div>




    </>

    )
}

export default Addaccount